// auth/ProtectedRoute.jsx — Anamoria SPA
// v1.1 — NEW-93: pass an opt-in login_hint (remembered email) so the Auth0
//   identifier screen is pre-filled for returning users. Additive — no stored
//   email ⇒ authorizationParams is {} and the flow is byte-for-byte unchanged.
// Guards any route that requires authentication.
// Behavior:
//   - Auth0 loading: show nothing (avoids flash of login redirect)
//   - Not authenticated: trigger Auth0 loginWithRedirect
//   - Authenticated: render children

import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { loginHintParams } from '../utils/rememberEmail';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: { returnTo: window.location.pathname },
        authorizationParams: loginHintParams(),
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  // While Auth0 checks session state, render nothing.
  // App.jsx handles the global loading screen.
  if (isLoading || !isAuthenticated) {
    return null;
  }

  return children;
}
